export class CsRandom {
    // Generate a random ID with a prefix cs_
    static generateId(prefix: string = 'cs_'): string {
        return `${prefix}${Math.random().toString(36).substr(2, 9)}`;
    }

    // Generate a random number within a range (inclusive)
    static generateNumber(min: number, max: number): number {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}